/**
 * Validates an email address.
 * 
 * @param {string} email - The email address to validate.
 * @returns {string|null} An error message if the email is invalid, or null if it's valid.
 */
export const validateEmail = (email: string): string | null => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      return "Por favor, ingrese un correo electrónico válido";
    }
    return null;
  };
  
  /**
   * Validates a password.
   * 
   * @param {string} password - The password to validate.
   * @returns {string|null} An error message if the password is invalid, or null if it's valid.
   */
  export const validatePassword = (password: string): string | null => {
    if (password.length < 8) {
      return "La contraseña debe tener al menos 8 caracteres";
    }
    return null;
  };
  